import type { ReactElement, ReactNode } from "react";
import styles from "./Chip.module.css";

export type ChipTone = "neutral" | "brand";

export interface ChipProps {
  children: ReactNode;
  selected?: boolean;
  size?: "md" | "sm";
  tone?: ChipTone;
  onClick?: () => void;
}

export function Chip({
  children,
  selected = false,
  size = "md",
  tone = "neutral",
  onClick,
}: ChipProps): ReactElement {
  const className = [
    styles.chip,
    size === "sm" ? styles.sm : "",
    selected ? styles.selected : "",
    selected && tone === "brand" ? styles.brand : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      type="button"
      className={className}
      aria-pressed={selected}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
